/**
 * Bosnia and Herzegovina convertible mark.
 */
export var BAM = {
  code: 'BAM',
  base: 10,
  exponent: 2
};